import gql from "graphql-tag";

export const GET_DEVICES = gql`
query {
    devices
    {
      id
    }
  }
`;